// Counter and dine-in orders are handed over in the restaurant, so they have no
// delivery address and there is nowhere to send a rider.
const IN_STORE_LABELS = { POS_COUNTER: 'Counter', POS_DINE_IN: 'Dine-in' }

export const inStoreLabel = order => IN_STORE_LABELS[order.orderType] || null

// `!== null` because not every order query asks for the address; the server
// refuses anything that gets past this.
export const canHaveRider = order =>
  !order.isPickedUp && !inStoreLabel(order) && order.deliveryAddress !== null
